// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para contêiner do formulário */
.Form_form_container__wSUjv {
    max-width: 100%;
    margin: 0 auto;
    background-color: #ffe7e7;
    border-radius: 15px;
    border: solid 0px;
}

.Form_form_container__wSUjv.Form_dark__J5II1 {
    background-color: #161414;
    color: #ffffff;
}

/* Estilos para o botão de submit */
.Form_form_container__wSUjv input[type="submit"] {
    margin: 3px 3px 3px 3px;
    border-radius: 8px;
    background-color: #25b456;
    color: #ffe7e7;
    border: none;
    min-width: 100px;
    min-height: 2.5rem;
    width: 100%;
    cursor: pointer;
    font-size: 1.1em;
    font-weight: bold;
    display: inline-block;
}

.Form_form_container__wSUjv input[type="submit"]:hover {
    background-color: #1c8a42;
}

/* Estilos para tabelas */
.Form_table__ZUFvK {
    border-collapse: separate;
    border-spacing: 0 1px;
    text-align: center;
}

.Form_th__Ux50b {
    padding: 10px;
    border: 1px solid #cccccc;
    font-weight: bold;
    background-color: #e8dfdf;
    color: #161414;
}

.Form_table__ZUFvK.Form_dark__J5II1 .Form_th__Ux50b {
    font-weight: bold;
    background-color: #383838;
    color: #161414;
}

.Form_td__wHFqi {
    padding: 10px;
    border: 1px solid #cccccc;
}

.Form_table__ZUFvK.Form_dark__J5II1 .Form_td__wHFqi {
    border-color: #595959;
    /* color: #ffffff; */
    color: #161414;
}

.Form_tbody__sfCtd tr:nth-child(even) {
    background-color: #e8dfdf;
    color: #161414;
}

.Form_table__ZUFvK.Form_dark__J5II1 tbody tr:nth-child(even) {
    background-color: #484848;
    /* color: #ffe7e7; */
    color: #161414;
}

.Form_tbody__sfCtd tr:nth-child(odd) {
    background-color: #ffffff;
    color: #161414;
}

.Form_table__ZUFvK.Form_dark__J5II1 tbody tr:nth-child(odd) {
    background-color: #949494;
    color: #ffffff;
}

/* Estilos adicionais */
.Form_preview_logomarca__4SjKD img {
    width: 80px;
    height: 80px;
    margin: 1em;
}

.Form_preview_bandeira__CIjKl {
    margin: 1em;
    margin-bottom: 1em;
    display: flex;
    flex-direction: row; /* Coloca as divs em linha */
    gap: 10px; /* Espaçamento entre as divs */
    flex-wrap: wrap; /* Permite quebra de linha se necessário */
    align-items: center; /* Centraliza os itens verticalmente */
}

.Form_stiloPadrao__53Aj4 {
    margin: 1em;
    margin-bottom: 1em;
    /*display: flex;*/
    gap: 10px; /* Espaçamento entre as divs */
    flex-wrap: wrap; /* Permite quebra de linha se necessário */
}

.Form_preview_avatar__VYorT img {
    width: 60px;
    height: 80px;
    margin: 1em;
    margin-bottom: 1em;
}

/* Estilos para formulário */
.Form_formPai__HCHlt {
    margin: 1em;
    margin-bottom: 1em;
}

.Form_formFilho__iFPsd {
    margin: 0.3em;
    margin-bottom: 0.3em;
}

/*
    .form_container {
        max-width: 80%;
        margin: 0 auto;
        background-color: #ffe7e7;
        border-radius: 15px;
        border: solid 0px;
    }

    .form_container.dark {
        background-color: #393939;
        color: #ffffff;
    }

    .form_container input[type="submit"] {
        margin: 3px 3px 3px 3px;
        border-radius: 8px;
        background-color: #25b456;
        color: #ffe7e7;
        border: none;
        min-width: 100px;
        min-height: 2.5rem;
        width: 100%;
        cursor: pointer;
        font-size: 1.1em;
        font-weight: bold;
        display: inline-block;
    }

    .form_container input[type="submit"]:hover {
        background-color: #1c8a42;
    }

    .form_container p {
        margin-top: 1em;
    }

    .form_container p a {
        color: #16479d;
        font-weight: bold;
    }

    .preview_logomarca {
        display: flex;
        justify-content: left;
        margin-bottom: 1em;
    }

    .preview_logomarca img {
        width: 80px;
        height: 80px;
        margin: 1em;
    }

    .preview_bandeira {
        margin: 1em;
        margin-bottom: 1em;
    }

    .preview_avatar img {
        width: 60px;
        height: 80px;
        margin: 1em;
        margin-bottom: 1em;
    }

    .table {
        border-collapse: separate;
        border-spacing: 0 1px;
        text-align: center;
    }

    .th {
        padding: 10px;
        border: 1px solid #cccccc;
        font-weight: bold;
        background-color: #e8dfdf;
    }

    .table.dark th {
        background-color: #393939;
        color: #ffffff;
    }

    .td {
        padding: 10px;
        border: 1px solid #cccccc;
    }

    .tbody tr:nth-child(even) {
        background-color: #e8dfdf;
    }

    .table.dark tbody tr:nth-child(even) {
        background-color: #484848;
        color: #ffe7e7;
    }

    .tbody td {
        font-weight: regular;
    }

    .tbody tr:nth-child(odd) {
        background-color: #ffffff;
    }

    .table.dark tbody tr:nth-child(odd) {
        background-color: #949494;
    }

    .formPai {
        margin: 1em;
        margin-bottom: 1em;
    }
    .formFilho {
        margin: 0.3em;
        margin-bottom: 0.3em;
    }
*/
`, "",{"version":3,"sources":["webpack://./src/components/form/Form.module.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB,EAAE,4BAA4B;IACjD,SAAS,EAAE,8BAA8B;IACzC,eAAe,EAAE,0CAA0C;IAC3D,mBAAmB,EAAE,sCAAsC;AAC/D;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,SAAS,EAAE,8BAA8B;IACzC,eAAe,EAAE,0CAA0C;AAC/D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsHC","sourcesContent":["/* Estilos para contêiner do formulário */\n.form_container {\n    max-width: 100%;\n    margin: 0 auto;\n    background-color: #ffe7e7;\n    border-radius: 15px;\n    border: solid 0px;\n}\n\n.form_container.dark {\n    background-color: #161414;\n    color: #ffffff;\n}\n\n/* Estilos para o botão de submit */\n.form_container input[type=\"submit\"] {\n    margin: 3px 3px 3px 3px;\n    border-radius: 8px;\n    background-color: #25b456;\n    color: #ffe7e7;\n    border: none;\n    min-width: 100px;\n    min-height: 2.5rem;\n    width: 100%;\n    cursor: pointer;\n    font-size: 1.1em;\n    font-weight: bold;\n    display: inline-block;\n}\n\n.form_container input[type=\"submit\"]:hover {\n    background-color: #1c8a42;\n}\n\n/* Estilos para tabelas */\n.table {\n    border-collapse: separate;\n    border-spacing: 0 1px;\n    text-align: center;\n}\n\n.th {\n    padding: 10px;\n    border: 1px solid #cccccc;\n    font-weight: bold;\n    background-color: #e8dfdf;\n    color: #161414;\n}\n\n.table.dark .th {\n    font-weight: bold;\n    background-color: #383838;\n    color: #161414;\n}\n\n.td {\n    padding: 10px;\n    border: 1px solid #cccccc;\n}\n\n.table.dark .td {\n    border-color: #595959;\n    /* color: #ffffff; */\n    color: #161414;\n}\n\n.tbody tr:nth-child(even) {\n    background-color: #e8dfdf;\n    color: #161414;\n}\n\n.table.dark tbody tr:nth-child(even) {\n    background-color: #484848;\n    /* color: #ffe7e7; */\n    color: #161414;\n}\n\n.tbody tr:nth-child(odd) {\n    background-color: #ffffff;\n    color: #161414;\n}\n\n.table.dark tbody tr:nth-child(odd) {\n    background-color: #949494;\n    color: #ffffff;\n}\n\n/* Estilos adicionais */\n.preview_logomarca img {\n    width: 80px;\n    height: 80px;\n    margin: 1em;\n}\n\n.preview_bandeira {\n    margin: 1em;\n    margin-bottom: 1em;\n    display: flex;\n    flex-direction: row; /* Coloca as divs em linha */\n    gap: 10px; /* Espaçamento entre as divs */\n    flex-wrap: wrap; /* Permite quebra de linha se necessário */\n    align-items: center; /* Centraliza os itens verticalmente */\n}\n\n.stiloPadrao {\n    margin: 1em;\n    margin-bottom: 1em;\n    /*display: flex;*/\n    gap: 10px; /* Espaçamento entre as divs */\n    flex-wrap: wrap; /* Permite quebra de linha se necessário */\n}\n\n.preview_avatar img {\n    width: 60px;\n    height: 80px;\n    margin: 1em;\n    margin-bottom: 1em;\n}\n\n/* Estilos para formulário */\n.formPai {\n    margin: 1em;\n    margin-bottom: 1em;\n}\n\n.formFilho {\n    margin: 0.3em;\n    margin-bottom: 0.3em;\n}\n\n/*\n    .form_container {\n        max-width: 80%;\n        margin: 0 auto;\n        background-color: #ffe7e7;\n        border-radius: 15px;\n        border: solid 0px;\n    }\n\n    .form_container.dark {\n        background-color: #393939;\n        color: #ffffff;\n    }\n\n    .form_container input[type=\"submit\"] {\n        margin: 3px 3px 3px 3px;\n        border-radius: 8px;\n        background-color: #25b456;\n        color: #ffe7e7;\n        border: none;\n        min-width: 100px;\n        min-height: 2.5rem;\n        width: 100%;\n        cursor: pointer;\n        font-size: 1.1em;\n        font-weight: bold;\n        display: inline-block;\n    }\n\n    .form_container input[type=\"submit\"]:hover {\n        background-color: #1c8a42;\n    }\n\n    .form_container p {\n        margin-top: 1em;\n    }\n\n    .form_container p a {\n        color: #16479d;\n        font-weight: bold;\n    }\n\n    .preview_logomarca {\n        display: flex;\n        justify-content: left;\n        margin-bottom: 1em;\n    }\n\n    .preview_logomarca img {\n        width: 80px;\n        height: 80px;\n        margin: 1em;\n    }\n\n    .preview_bandeira {\n        margin: 1em;\n        margin-bottom: 1em;\n    }\n\n    .preview_avatar img {\n        width: 60px;\n        height: 80px;\n        margin: 1em;\n        margin-bottom: 1em;\n    }\n\n    .table {\n        border-collapse: separate;\n        border-spacing: 0 1px;\n        text-align: center;\n    }\n\n    .th {\n        padding: 10px;\n        border: 1px solid #cccccc;\n        font-weight: bold;\n        background-color: #e8dfdf;\n    }\n\n    .table.dark th {\n        background-color: #393939;\n        color: #ffffff;\n    }\n\n    .td {\n        padding: 10px;\n        border: 1px solid #cccccc;\n    }\n\n    .tbody tr:nth-child(even) {\n        background-color: #e8dfdf;\n    }\n\n    .table.dark tbody tr:nth-child(even) {\n        background-color: #484848;\n        color: #ffe7e7;\n    }\n\n    .tbody td {\n        font-weight: regular;\n    }\n\n    .tbody tr:nth-child(odd) {\n        background-color: #ffffff;\n    }\n\n    .table.dark tbody tr:nth-child(odd) {\n        background-color: #949494;\n    }\n\n    .formPai {\n        margin: 1em;\n        margin-bottom: 1em;\n    }\n    .formFilho {\n        margin: 0.3em;\n        margin-bottom: 0.3em;\n    }\n*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_container": `Form_form_container__wSUjv`,
	"dark": `Form_dark__J5II1`,
	"table": `Form_table__ZUFvK`,
	"th": `Form_th__Ux50b`,
	"td": `Form_td__wHFqi`,
	"tbody": `Form_tbody__sfCtd`,
	"preview_logomarca": `Form_preview_logomarca__4SjKD`,
	"preview_bandeira": `Form_preview_bandeira__CIjKl`,
	"stiloPadrao": `Form_stiloPadrao__53Aj4`,
	"preview_avatar": `Form_preview_avatar__VYorT`,
	"formPai": `Form_formPai__HCHlt`,
	"formFilho": `Form_formFilho__iFPsd`
};
export default ___CSS_LOADER_EXPORT___;
